import { Component, OnInit, Input, HostListener, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { ValidationService } from '../validation.service';
import { StorageService } from '../storage.service';
import { Subscription, Observable, fromEvent, merge, interval } from 'rxjs';
import { EventService } from '../event.service';
import { SocketService } from '../socket.service';
import { SnackbarService } from '../snackbar.service';
import { HttpService } from '../http.service';
import { Messages } from '../constants/messages';
import { TimeService } from '../time.service';
import { MessagingService } from '../messaging.service';
import { environment } from 'src/environments/environment';
import { switchMap, take, tap, skipWhile } from 'rxjs/operators';
import { init } from 'echarts';
import { LoaderService } from '../loader.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  // Idle Varibles
  inactivityTimerEvent: Array<any>[] =
    [
      [document, 'click'],
      [document, 'wheel'],
      [document, 'scroll'],
      [document, 'mousemove'],
      [document, 'keyup'],
      [window, 'resize'],
      [window, 'scroll'],
      [window, 'mousemove']
  ];
  mergedObservable$;
  observeable$;
  timeLapsedSinceInactivity;
  inactivityTime = 300;
  ///

  showUnits = false;
  selectedUnit: any = {
    _id: '',
    name: ''
  };

  units: any = [];
  userName = '';
  socket: any;
  showNotificationBox = false;
  notifications: any = [];

  carrierUpdates: Subscription;
  messages = new Messages();


  languages = [
    {
      name: 'English',
      code: 'en'
    }
  ];
  roles: any = {
    postShipment: false,
    lanes: false,
    fleet: false,
    shippers: false,
    locationMasterList: false,
    accounting: false,
    user: false,
    unit: false,
    owner: false
  };
  subscription;

  @Input('headerRTL') headerRTL: string;
  country: string;
  @HostListener('document:click', ['$event']) onDocumentClick(event) {
    this.showNotificationBox = false;
  }

  constructor(private router: Router, private timeService: TimeService,
              private valid: ValidationService, private fcmService: MessagingService,
              private storage: StorageService,
              private events: EventService,
              private http: HttpService, private _ngZone: NgZone,
              public loader: LoaderService,
              private snack: SnackbarService) {
                if(environment.country == "SA"){
                  this.languages.push({
                    name: 'Arabic',
                    code: 'ar'
                  });
                }
                if(environment.country == "BR"){
                  this.languages.push({
                    name: 'Portugese',
                    code: 'br'
                  });
                }
               }

  ngOnInit() {
    this.country = environment.country;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.initRoles();
    this.inactivityTime = parseInt(localStorage.getItem('idleTime')) * 60;
    this.initIdleTimeMechanism();

    this.events.idleTimerChanges().subscribe(e => {
      if (this.subscription) {
        this.subscription.unsubscribe();
        this.initRoles();
      }
      this.inactivityTime = parseInt(localStorage.getItem('idleTime')) * 60;
      this.initIdleTimeMechanism();
    });






    this.userName = this.storage.getFromCookie('user_name');
    this.setupFCM();
    this.fetchNotifications();
    this.initUnits();
    this.carrierUpdates = this.events.CarrierValuesUpdated().subscribe(
      (data: any) => {
        this.initUnits();
      }
    );

    this.events.accessTokenChanges().subscribe(
      data => {
        if(data){
          this.userName = this.storage.getFromCookie('user_name');
          this.initUnits();
          this.carrierUpdates = this.events.CarrierValuesUpdated().subscribe(
            (data: any) => {
              this.initUnits();
            }
          );
        }
      }
    );
  }

  initIdleTimeMechanism() {
    // Init an observable based idle management system

    const observableArray$: Observable<any>[] = [];
    this.inactivityTimerEvent.forEach(x => {
      observableArray$.push(fromEvent(x[0], x[1]));
    });
    this.mergedObservable$ = merge(...observableArray$);
    this.createObserable();


    /////////////////// End of Idle Management
  }

  unsubscribeObservable() {

  }
  subscribeObservable() {
    this.subscription = this.observeable$.subscribe((x) => {
      console.log(`subscribed for ${x + 1} sec`);
      this.logout();
      this.unsubscribeObservable();
    });
  }
  isItTimeToShowPopUp(v) {
    if (v == this.inactivityTime - 5) {
      this.snack.openSnackBar('You will be logged out soon for inactivity');
    }
  }
  createObserable(): void {
    this._ngZone.runOutsideAngular(() => {

      this.observeable$ = this.mergedObservable$
      .pipe(
        switchMap(ev => interval(1000 ).pipe(take(this.inactivityTime))),
        tap(value => this.isItTimeToShowPopUp(value)),
        skipWhile((x) => {
          this.timeLapsedSinceInactivity = x;
          return x != this.inactivityTime - 1;
        })
      );
      this.subscribeObservable();
    });
  }





  changeLang(code) {
    this.events.setLanguageUpdates(code);
  }

  initSockets() {
    this.socket = new SocketService();
    const access = this.storage.getFromCookie('access_token');
    this.socket.auth('auth', { token: access }, (data: any) => {
      this.joinRoom(this.selectedUnit._id);
    });
  }

  joinRoom(room: any) {
    this.socket.emit('unit', { room });
    this.listenToRoom();
  }
  changeRoom(oldId: any, newId: any) {
    this.socket.emit('unit', { oldUnit: oldId, newUnit: newId });
  }
  listenToRoom() {
    // when new bid order is created
    this.socket.listen('new_bid_order').subscribe(
      (data) => {
        this.events.setBidOrderUpdate(data);
        this.snack.showNotification(`${data.OIN} ${this.messages.SOCKET.SUCCESS.NEW_BID_ORDER}`);
      }
    );
    // when new bid is placed
    this.socket.listen('new_bid').subscribe(
      (data) => {
        if (data.code == 412) {
          this.events.setBidUpdates(data);// update the bid data in open bids
        } else {
          const message = `${this.messages.SOCKET.SUCCESS.NEW_BID} ${data.OIN} : ${this.selectedUnit.currency} ${data.amount}`;
          this.events.setBidUpdates(data);
          this.snack.showNotification(message);
        }
      }
    );
    // when bid is won/lost
    this.socket.listen('bid_result').subscribe(
      (data) => {
        const message = `${this.messages.SOCKET.SUCCESS.BID_STATUS} ${data.status} : ${data.OIN}`;
        this.events.setBidUpdates(data);
        this.snack.showNotification(message);
      }
    );
    // when bid is stopped
    this.socket.listen('bid_stop').subscribe(
      (data) => {
        if (data.code == 410) {// participated in the bidding
          const message = `${data.OIN} ${this.messages.SOCKET.SUCCESS.BID_STOPPED}`;
          this.snack.showNotification(message);
          this.events.setBidOrderStatus(data);
        } else if (data.code == 412) {// not participated
          this.events.setBidOrderStatus(data);
        }
      }
    );
  }

  listenDisconnect() {
    this.socket.listen('disconnect').subscribe(
      (data) => {
        this.socket.disconnect();
        this.socket = undefined;
      }
    );
  }

  ngOnDestroy() {
    this.carrierUpdates.unsubscribe();
  }

  initUnits() {
    const unitsArray: any = JSON.parse(this.storage.getFromLocalStorage('carriers'));

    this.units = [];
    unitsArray.forEach(element => {
      const temp: any = {};
      temp._id = element._id;
      temp.name = element.name;
      temp.parent_name = element.parent_name;
      temp.country_code = element.country.country_code;
      if (element.country && element.country.currency) {
        temp.currency = element.country.currency.symbol;
      }
      this.units.push(temp);
    });

    const selected: any = this.storage.getFromCookie('carrier_id');
    if (!selected) {
      this.selectedUnit = this.units[0];
    } else {
      this.selectedUnit = this.units.filter(uni => {
        return uni._id == selected;
      })[0];
    }

    this.storage.setCookie('country_code', this.selectedUnit.country_code);
    this.storage.setCookie('currency', this.selectedUnit.currency);
    this.storage.setCookie('unit_name', this.selectedUnit.name);
    this.initSockets();
    this.listenDisconnect();



    this.storage.setCookie('carrier_id', this.selectedUnit._id);
  }

  logout() {
    this.http.put('carrier_user/sign_out?from=web', {}).subscribe(
      (response: any) => {
        this.fcmService.removeToken();
      }
    );
    localStorage.clear();
    const langPref = this.storage.getFromCookie('langPref');
    this.storage.deleteAllCookies();
    this.storage.setCookie('langPref', langPref);
    this.events.setAccessTokenChanges(false);
    this.socket.disconnect();
    this.units = [];
    this.router.navigateByUrl('login');
  }

  selectUnit(unit: any, lastId = this.selectedUnit._id) {
    const oldUnit: any = this.storage.getFromCookie('carrier_id');
    this.selectedUnit = unit;
    this.storage.deleteCookie('carrier_id');
    this.storage.deleteCookie('unit_name');
    this.storage.setCookie('carrier_id', this.selectedUnit._id);
    this.storage.setCookie('unit_name', this.selectedUnit.name);
    this.storage.setCookie('currency', this.selectedUnit.currency);
    this.storage.setCookie('country_code', this.selectedUnit.country_code);
    this.http.refreshAccessToken();
    this.events.setCarrierId(this.selectedUnit._id);
    if (oldUnit != this.selectedUnit._id) {
      this.changeRoom(oldUnit, this.selectedUnit._id);
    }
  }

  setupFCM() {
    this.fcmService.requestPermission();
    this.fcmService.fcmToken.subscribe(token => {
      if (token) { this.fcmService.receiveMessage(); }
      if (token && (token != localStorage.getItem('fcmToken') || '')) {
        this.http.post('carrier_user/update_fcm', {web_fcm_token: token}).subscribe(
          (data: any) => {
            if (data.statusCode == 200) {
              localStorage.setItem('fcmToken', token);
            }
          }
        );
      }
    });
    this.fcmService.currentMessage.subscribe(
      (message) => {
        console.log(' Messgae :: ',message)
        if (message) {
          const options = {
            body: message.notification.body,
          };
          const notify = new Notification(message.notification.title, options);
          this.setNotification({title: message.notification.title, body: message.notification.body, time: Date.now()});
        }
      }
    );
  }

  toggleNotifications() {
    this.showNotificationBox = !this.showNotificationBox;
  }

  getHoursandMinutes(seconds) {
    return this.timeService.getHoursandMinutes(seconds);
  }

  fetchNotifications() {
    this.notifications = [];
    this.notifications  = JSON.parse(this.storage.getSession('notifications'));
    return this.notifications;
  }

  setNotification(notification) {
    const a = this.fetchNotifications() || [];
    a.push(notification);
    this.storage.setSession('notifications', JSON.stringify(a));
    this.notifications = a;
    return a;
  }
  initRoles() {
    const local = JSON.parse(localStorage.getItem('roles'));
    if (this.roles) {
    local.forEach(element => {
      if (element.value === 'shipment_executive' || element.value === 'shipment_administrator') {
        this.roles.postShipment = true;
      }
      if (element.value === 'account_owner') {
        this.roles.owner = true;
      }
      if (element.value === 'unit_administrator') {
        this.roles.unit = true;
      }
      if (element.value === 'user_administrator') {
        this.roles.user = true;
      }
      if (element.value === 'shipper_administrator') {
        this.roles.shippers = true;
      }
      if ((element.value === 'finance_executive' || element.value === 'finance_administrator')) {
        this.roles.accounting = true;
      }
      if ((element.value === 'fleet_executive' || element.value === 'fleet_administrator')) {
        this.roles.fleet = true;
      }
    });
    }
  }
}
